<template>
  <div class="datainfo-wrap" v-if="is_wrap">
    <div class="text">{{ value_text }}</div>
    <div class="value" v-if="!sum">---</div>
    <div class="value" v-else>
      {{ showNumber(sum) }}
      <!-- <svg-icon name="arrow-up" v-if="sum && sum !== 0 && trend !== 'same'" :class="trend" /> -->
    </div>
  </div>
  <div class="the-type" :class="{ selected: chart_type === chart_type_text }" @click="clickType(chart_type_text)">
    <template v-if="!is_wrap">
      <div class="value" v-if="!sum">---</div>
      <div class="value" v-else>
        {{ showNumber(sum) }}
        <svg-icon name="arrow-up" v-if="sum && sum !== 0 && trend !== 'same'" :class="trend" />
      </div>
      <div class="text-big">{{ value_text }}</div>
    </template>

    <div class="desc-box" v-if="show_sortlink">
      <div class="desc">
        <div class="desc-text">Shortlinks</div>
        <div class="desc-text">
          {{ chart_type_text === 'sales' || chart_type_text === 'earnings' ? `$` : ``
          }}{{ sort_value.toLocaleString('en-US') }}
        </div>
      </div>
      <div class="desc">
        <div class="desc-text">Storefront</div>
        <div class="desc-text">
          {{ chart_type_text === 'sales' || chart_type_text === 'earnings' ? `$` : ``
          }}{{ store_value.toLocaleString('en-US') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryValue',

  components: {},

  data() {
    return {};
  },

  props: {
    is_wrap: {
      type: Boolean,
      default: false,
    },
    chart_type: {
      type: String,
      default: '',
    },
    chart_type_text: {
      type: String,
      default: '',
    },

    sum: {
      type: Number,
      default: 0,
    },

    trend: {
      type: String,
      default: '',
    },

    value_text: {
      type: String,
      default: '',
    },

    show_sortlink: {
      type: Boolean,
      default: true,
    },

    sort_value: {
      type: [String, Number],
      default: 0,
    },

    store_value: {
      type: [String, Number],
      default: 0,
    },
  },

  methods: {
    clickType() {
      this.$emit('clickType', this.chart_type_text);
    },
    showNumber(num) {
      if (!num || num === 0 || num === '0.00' || num === null || typeof num === 'undefined' || num === '') {
        return '--';
      }

      if (this.chart_type_text === 'sales' || this.chart_type_text === 'earnings') {
        return `$${num.toLocaleString('en-US')}`;
      }

      return Number(num).toLocaleString('en-US');
    },
  },
};
</script>
<style lang="scss">
.the-type {
  width: 25%;
  padding: 16px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;

  &.selected {
    background: var(--bg-02);
    border: unset;
  }

  .text-big {
    font: var(--font-med-16);
    color: var(--text-secondary);
  }

  .desc-text {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: var(--black-75);
  }

  .value {
    font: var(--font-med-24);
    color: var(--dark-blue);
    display: flex;
    align-items: center;
    width: 100%;

    svg {
      margin-left: 10px;
      width: 10px;
      height: 10px;
      fill: var(--green);

      &.down {
        fill: var(--red);
        transform: rotate(90deg);
      }
    }
  }

  .desc-box {
    margin-top: 12px;
    width: 100%;

    .desc {
      margin-top: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
